import arrowLeft from "../../assets/images/arrow-left.png";
import "./NextStepButton.scss";

const NextStepButton = (props: {text?: string, sytle?:{},onclick:(val:boolean)=>void}) => {
  return (
    <button className="register-first-step-button" type="submit" style={props.sytle ? props.sytle : {marginBottom:35}} onClick={()=>{props.onclick(true)}} >
        <span>{props.text}</span>
        <img src={arrowLeft} alt="left" />
    </button>
  );
};

export default NextStepButton;
